<template>
  <div class="categories-page">
    <main class="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- 页面标题 -->
      <div class="text-center mb-12">
        <h1 class="text-3xl font-bold mb-3">工具分类</h1>
        <p class="text-neutral-500 max-w-2xl mx-auto">
          浏览不同类别的AI工具，找到你需要的创意解决方案
        </p>
      </div>

      <!-- 分类卡片网格 -->
      <div
        v-if="!selectedCategory"
        class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 mb-16"
      >
        <div
          v-for="category in categories"
          :key="category.id"
          class="bg-white rounded-xl border border-neutral-200 p-5 text-center hover-lift transition-all duration-300 cursor-pointer category-card"
          @click="selectCategory(category)"
        >
          <div
            class="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
            :style="{
              backgroundColor: category.color + '20',
              color: category.color,
            }"
          >
            <i :class="['fa', category.icon, 'text-2xl']"></i>
          </div>
          <h3 class="font-bold mb-1">{{ category.title }}</h3>
          <p class="text-neutral-500 text-sm">
            {{ category.toolCount }} 个工具
          </p>
        </div>
      </div>

      <!-- 工具列表区域 -->
      <div v-else id="category-tools" class="animate-fade-in">
        <div class="flex items-center justify-between mb-8">
          <div class="flex items-center">
            <button
              @click="clearCategory"
              class="mr-4 text-neutral-500 hover:text-primary transition-colors"
            >
              <i class="fa fa-arrow-left"></i>
            </button>
            <div
              class="inline-block w-8 h-8 mr-2 rounded-full flex items-center justify-center"
              :style="{
                backgroundColor: selectedCategory.color + '20',
                color: selectedCategory.color,
              }"
            >
              <i :class="['fa', selectedCategory.icon, 'text-sm']"></i>
            </div>
            <h2 class="text-2xl font-bold">
              {{ selectedCategory.title }} 工具
            </h2>
          </div>
        </div>

        <div v-if="loading" class="text-center py-10">
          <i class="fa fa-spinner fa-spin text-primary text-2xl"></i>
        </div>

        <div
          v-else-if="categoryTools.length > 0"
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          <div
            v-for="tool in categoryTools"
            :key="tool.id"
            class="bg-white rounded-xl border border-neutral-200 overflow-hidden hover-lift transition-all duration-300 cursor-pointer"
            @click="openToolDetail(tool)"
          >
            <div class="h-48 overflow-hidden bg-neutral-100 relative group">
              <img
                :src="tool.cover"
                :alt="tool.title"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div
                class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"
              ></div>
              <div class="absolute top-3 right-3 flex">
                <div
                  class="bg-white/90 backdrop-blur-sm px-2 py-1 rounded text-xs font-medium text-neutral-600"
                >
                  {{ selectedCategory.title }}
                </div>
                <div
                  class="ml-2 bg-white/90 backdrop-blur-sm px-2 py-1 rounded text-xs font-medium text-neutral-600"
                  v-if="getSubName(tool.subid).length > 0"
                >
                  {{ getSubName(tool.subid) }}
                </div>
              </div>
            </div>
            <div class="p-5">
              <div class="flex justify-between items-start mb-2">
                <h3 class="font-bold text-lg truncate pr-2">
                  {{ tool.title }}
                </h3>
                <div
                  class="flex items-center text-xs text-yellow-500 font-medium bg-yellow-50 px-2 py-1 rounded"
                >
                  <i class="fa fa-star mr-1"></i>{{ tool.rating }}
                </div>
              </div>
              <p class="text-neutral-500 text-sm mb-4 line-clamp-2 h-10">
                {{ tool.description }}
              </p>
              <div
                class="flex items-center justify-between pt-4 border-t border-neutral-100"
              >
                <div class="text-xs text-neutral-400">
                  <i class="fa fa-download mr-1"></i>
                  {{ formatNumber(tool.downloadCount) }}
                </div>
                <button
                  class="text-primary hover:text-primary/80 text-sm font-medium"
                >
                  查看详情 <i class="fa fa-chevron-right text-xs ml-1"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="flex justify-end w-full col-span-1 md:col-span-3">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              @current-change="pageChange"
            />
          </div>
        </div>

        <div v-else class="text-center py-16">
          <div class="inline-block p-4 rounded-full bg-neutral-100 mb-4">
            <i class="fa fa-search text-neutral-400 text-2xl"></i>
          </div>
          <h3 class="text-lg font-medium text-neutral-900 mb-1">暂无工具</h3>
          <p class="text-neutral-500">该分类下暂时没有工具，敬请期待。</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { globalState } from "@/state";
export default {
  name: "CategoriesPage",
  data() {
    return {
      categories: [],
      // tools,
      selectedCategory: null,
      loading: false,
      categoryTools: [],
      page: 1,
      pageSize: 10,
      total: 0,
      subList: [],
    };
  },
  created() {
    this.getCategory();
  },
  watch: {
    "$route.query.category": {
      handler() {
        this.getCategory();
      },
    },
  },
  methods: {
    getCategory() {
      this.$axios({
        url: "subinfo/list",
      }).then((res) => {
        this.subList = res.data;
      });
      this.$axios({
        url: "category/list/count",
      }).then(async (res) => {
        this.categories = res.data;
        await this.checkQueryParam();
      });
    },
    getSubName(id) {
      var sub = this.subList.find((c) => c.id === id);
      return sub ? sub.title : "";
    },
    openToolDetail(tool) {
      // globalState.openModal(tool);
      globalState.openModal(tool.id, this.categories);
    },
    async checkQueryParam() {
      const categoryId = this.$route.query.category;
      if (categoryId) {
        const category = this.categories.find((c) => c.id === categoryId);
        if (category) {
          await this.selectCategory(category, false);
        }
      } else {
        this.selectedCategory = null;
      }
    },
   async pageChange(page) {
      this.page = page;
      await this.selectCategory(this.selectCategory);
    },
    async selectCategory(category, updateUrl = true) {
      this.selectedCategory = category;
      this.loading = true;

      // 更新 URL
      if (updateUrl) {
        this.$router.push({ query: { category: category.id } });
      }

      var data = await this.$aesEncrypt({
        searchKey: this.searchQuery,
        page: this.page,
        pageSize: this.pageSize,
      });
      this.$axios({
        url: "aitool/list/category/" + category.id,
        method: "POST",
        data: {
          data: data,
        },
      }).then((res) => {
        this.loading = false;
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (res.code == 200) {
          this.total = res.data.total;
          this.categoryTools = res.data.list;
        }
      });
      // 模拟加载延迟
      // setTimeout(() => {
      //   this.categoryTools = this.tools.filter(
      //     (t) => t.category_id === category.id
      //   );
      //   this.loading = false;
      //   // 滚动到顶部
      //   window.scrollTo({ top: 0, behavior: "smooth" });
      // }, 300);
    },
    clearCategory() {
      this.selectedCategory = null;
      this.$router.push({ query: {} });
    },
    formatNumber(num) {
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + "k";
      }
      return num;
    },
  },
};
</script>
